import React from 'react';
import Alert from './Alert';
import Button from './Button';

const DuplicateWarning = ({ duplicateInfo, onContinue, onCancel }) => {
  const { existingData, duplicateField, message } = duplicateInfo;

  return (
    <div className="space-y-4">
      <Alert 
        type="warning" 
        message={message}
      />
      
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
        <h3 className="text-lg font-semibold text-yellow-800 mb-3">
          Cadastro Existente Encontrado
        </h3>
        
        <div className="space-y-2 text-sm">
          <p className="text-yellow-700">
            <strong>Nome:</strong> {existingData.nome}
          </p>
          <p className="text-yellow-700">
            <strong>Telefone:</strong> {existingData.telefone}
          </p>
          {existingData.email && (
            <p className="text-yellow-700">
              <strong>E-mail:</strong> {existingData.email}
            </p>
          )}
        </div>
        
        <div className="mt-4 p-3 bg-yellow-100 rounded border border-yellow-300">
          <p className="text-yellow-800 text-sm">
            <strong>⚠️ Atenção:</strong> Este {duplicateField === 'telefone' ? 'telefone' : 'e-mail'} já está cadastrado em nosso sistema.
          </p>
        </div>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <h4 className="text-md font-semibold text-blue-800 mb-2">
          O que você gostaria de fazer?
        </h4>
        <ul className="text-sm text-blue-700 space-y-1">
          <li>• <strong>Cancelar:</strong> Voltar e corrigir os dados</li>
          <li>• <strong>Continuar:</strong> Prosseguir mesmo assim (não recomendado)</li>
        </ul>
      </div>

      <div className="flex flex-col sm:flex-row gap-3 pt-4">
        <Button
          onClick={onCancel}
          variant="secondary"
          className="flex-1"
        >
          Voltar e Corrigir
        </Button>
        <Button
          onClick={onContinue}
          variant="outline"
          className="flex-1"
        >
          Continuar Mesmo Assim
        </Button>
      </div>
    </div>
  );
};

export default DuplicateWarning;
